/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useMemo } from 'react';
import { useQuery } from 'react-apollo';

import { usePageSpaceKey } from '@confluence/page-context';

import { normalizeSpaceAdminData } from '../normalizers/normalizeSpaceAdminData';

import type {
	useSpaceAdminDetailsPanelSpaceAdminQuery as useSpaceAdminDetailsPanelSpaceAdminQuery$data,
	useSpaceAdminDetailsPanelSpaceAdminQueryVariables as useSpaceAdminDetailsPanelSpaceAdminQuery$variables,
} from './__types__/useSpaceAdminDetailsPanelSpaceAdminQuery';

const useSpaceAdminDetailsPanelSpaceAdminQuery = gql`
	query useSpaceAdminDetailsPanelSpaceAdminQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			currentUser {
				isAdmin
			}
		}
	}
`;
export const useSpaceAdmin = () => {
	const [spaceKey] = usePageSpaceKey();
	const { data, loading, error, refetch } = useQuery<
		useSpaceAdminDetailsPanelSpaceAdminQuery$data,
		useSpaceAdminDetailsPanelSpaceAdminQuery$variables
	>(useSpaceAdminDetailsPanelSpaceAdminQuery, {
		skip: !spaceKey,
		variables: {
			spaceKey: spaceKey ?? '',
		},
	});
	const normalizedData = useMemo(() => normalizeSpaceAdminData(data), [data]);

	return {
		data: normalizedData,
		loading,
		error,
		refetch,
	};
};
